import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const NAV = [
  { to: '/',              label: 'Tableau de bord',        roles: ['ADHERENT','GESTIONNAIRE','ADMIN','PRESIDENT_REGION'] },
  { to: '/bilans',        label: 'Bilans',                 roles: ['ADHERENT','GESTIONNAIRE','ADMIN','PRESIDENT_REGION'] },
  { to: '/classements',   label: 'Classements',            roles: ['ADHERENT','GESTIONNAIRE','ADMIN','PRESIDENT_REGION'] },
  { to: '/adherents',     label: 'Adhérents',              roles: ['GESTIONNAIRE','ADMIN'] },
  { to: '/users',         label: 'Utilisateurs',           roles: ['GESTIONNAIRE','ADMIN'] },
  { to: '/configuration', label: 'Configuration',          roles: ['ADMIN'] },
  { to: '/journal',       label: 'Journal connexions',      roles: ['ADMIN'] },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api.get('/users/me/profile').then(({ data }) => setProfile(data)).catch(() => {});
  }, []);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-inner">
            <img
              className="logo-img"
              src="/logo-ecf.png"
              alt="Logo ECF"
            />
            <div className="logo-subtitle">Analyse<br />des bilans</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section-title">Navigation</div>
          {NAV.filter(n => n.roles.includes(user?.role)).map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          {profile ? (
            <>
              <div className="user-name">{profile.prenom} {profile.nom}</div>
              <div className="user-info">{profile.nom_commercial}</div>
            </>
          ) : (
            <div className="user-name">—</div>
          )}
          <div className="user-role">{user?.role}</div>
          <button className="btn btn-outline"
            style={{ marginTop: 12, width: '100%', justifyContent: 'center', fontSize: '0.7rem',
                     borderColor: 'rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.7)' }}
            onClick={handleLogout}>
            Déconnexion
          </button>
        </div>
      </aside>

      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
}
